import React from 'react'
import Head from './Head/Head'

const contact = () => {
  return (
    <>
    <Head/>
    <div style={{padding:'10rem'}}>contact</div>
    </>
    
  )
}

export default contact